/**
 * @generated SignedSource<<5f014b4044459efb94c4edb99f926dd1>>
 * @relayHash 402a674bdd82767605c36953e2732f07
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5b2ad70438dbcc77ff45c7608ecd4e7382a18aa895a82fd26e83279a282b7ab6

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_globalPermissionsAndGrantsQuery$variables = {
  cloudId: string;
};
export type main_globalPermissionsAndGrantsQuery$data = {
  readonly jira: {
    readonly globalPermissionsAndGrants: {
      readonly " $fragmentSpreads": FragmentRefs<"globalPermissionsTable_globalPermissions" | "grantPermissionDialog_globalPermissions">;
    };
  };
};
export type main_globalPermissionsAndGrantsQuery = {
  response: main_globalPermissionsAndGrantsQuery$data;
  variables: main_globalPermissionsAndGrantsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "main_globalPermissionsAndGrantsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "alias": "globalPermissionsAndGrants",
                "args": (v1/*: any*/),
                "kind": "LinkedField",
                "name": "getGlobalPermissionsAndGrants",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "globalPermissionsTable_globalPermissions"
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "grantPermissionDialog_globalPermissions"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.globalPermissionsAndGrants"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "main_globalPermissionsAndGrantsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "globalPermissionsAndGrants",
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "getGlobalPermissionsAndGrants",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "JiraGlobalPermissionGrants",
                    "kind": "LinkedField",
                    "name": "globalPermissionGrants",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraGlobalPermission",
                        "kind": "LinkedField",
                        "name": "permission",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "description"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "key"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isManagedByJira"
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__id"
                          }
                        ]
                      },
                      {
                        "concreteType": "JiraGroup",
                        "kind": "LinkedField",
                        "name": "groups",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "groupId"
                          },
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "JiraGlobalPermissionGrantsList"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "5b2ad70438dbcc77ff45c7608ecd4e7382a18aa895a82fd26e83279a282b7ab6",
    "metadata": {},
    "name": "main_globalPermissionsAndGrantsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9f1b7eb98b606c41655e4fa1f200a351";

export default node;
